import { snackbarProgrammatic } from '@/components/snackbar';
import { ClientDuplicatesUpdated } from '@/shared/events/client-duplicates-updated';
import { User } from '@/shared/user';
import store from '@/store';

async function handleClientDuplicatesUpdated(data: ClientDuplicatesUpdated): Promise<void> {
    const currentUser: User | null = store.getters['user/user'];

    if (currentUser == null || currentUser.id! !== data.userId) {
        return;
    }

    snackbarProgrammatic.open({ message: `Client duplicates updated.`, type: 'is-success' });
}

export default handleClientDuplicatesUpdated;
